module.exports = __webpack_public_path__ + "img/eyes_male_thin.530958fc.png";